import { PurseDetailUI } from './_components/purse-detail-view'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectSelectedProgram } from '@/storage/programs/slice'
import PageLoader from '@/app/common/components/PageLoader'
import useProgramPurseQuery from '@/queries/program_purses/useProgramPurseQuery.ts'

export default function PurseDetailView() {
  const purseId = useParams().purseId as string
  const programId = useSelector(selectSelectedProgram).id
  const query = useProgramPurseQuery({ purseId, programId })

  return (
    <PageLoader query={query}>
      {(purse) => {
        return (
          <div className="container mx-auto p-6">
            <PurseDetailUI purse={purse} />
          </div>
        )
      }}
    </PageLoader>
  )
}
